import React, { ChangeEvent, useRef } from 'react';

import { Button as MaterialButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import UploadIcon from '@mui/icons-material/CloudUploadOutlined';

import clsx from 'clsx';

import { useStyles } from './AppUploadFileButton.styles';

interface ICustomButtonProps {
  onFileInput?: (event: ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
  variant?: 'text' | 'outlined' | 'contained';
}

export function AppUploadFileButton({
  label,
  variant = 'contained',
  className,
  disabled,
  onFileInput,
}: ICustomButtonProps) {
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const fileUploadButtonRef = useRef<HTMLInputElement | null>(null);

  return (
    <MaterialButton
      variant={variant}
      className={clsx(classes.button, className)}
      onClick={() => fileUploadButtonRef.current?.click()}
      disabled={disabled}>
      <UploadIcon />
      {label}
      <input
        ref={fileUploadButtonRef}
        autoComplete="off"
        multiple
        accept="image/png, image/jpeg"
        style={{ display: 'none' }}
        tabIndex={-1}
        type="file"
        onChange={onFileInput}
      />
    </MaterialButton>
  );
}

export default AppUploadFileButton;
